import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getPhoneLineBillingViaPhoneNumber = (phoneNumber: string | undefined): Promise<IGetPhoneLineBillingViaPhoneNumber[]> => {
  return axiosDefaultApi.get(`api/Billing/GetDetailsForPhoneLines/${phoneNumber}`);
};

type QueryFnType = typeof getPhoneLineBillingViaPhoneNumber;

type UseGetPhoneLineBillingViaPhoneNumberOptions = {
  phoneNumber: string;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPhoneLineBillingViaPhoneNumber = ({ phoneNumber , config }: UseGetPhoneLineBillingViaPhoneNumberOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getPhoneLineBillingViaPhoneNumber_${phoneNumber}`],
    queryFn: () => getPhoneLineBillingViaPhoneNumber(phoneNumber),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της χρέωσης τηλεφωνικής γραμμής.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};